import React, { useState, useEffect } from "react";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";
import "./ArchetypeTimeline.css";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import noimage from "../../images/image.jpeg";

function ArchetypeTimeline({ token }) {
  const [isLoading, setIsLoading] = useState(true);
  const [UserData, setUserData] = useState([]);
  const [TestDates, setTestDates] = useState([]);

  const [backButton, setbackButton] = useState("");

  const Bgcolors = ["#ebddf1", "#afe2ca", "#c6f5ff", "#f4e9c7", "#ffaeb5"];

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${END_URL}/fetch_all_result`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const responsedata = response?.data;

      setUserData(responsedata?.user_data || []);
      setTestDates(responsedata?.unique_test_created_date || []);
      setbackButton(responsedata?.back_to_dashboard);
      setIsLoading(false);

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      console.log("Error fetching archetype timeline data:", error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="newdash-graph-main skeleton3-section-">
        <div className="skeleton3 sklbann"></div>
      </div>
    );
  }

  if (UserData.length === 0) {
    return null;
  }

  return (
    <section className="arch_time_line-section">
      <div className="container arch_time_line_container">
        <div className="row">
          {/* <div className="back-dahboard">
            <a className="button back-return" href="/dashboard">
              Back to Dashboard !
              <span>
                <FontAwesomeIcon className="icc" icon={faArrowRight} />
              </span>
            </a>
          </div> */}

          <div className="newdash-graph-main arch_time_line">
            <h4>Archetype Timeline</h4>

            <div className="newdash-graph-outer">
              <div className="row newdash-graph-inner-row">
                <div className="newdash-graph">
                  {UserData.length > 0 && (
                    <div className="col-md-12 first-name">
                      {UserData.map((user, rowIndex) => (
                        <div className="row newdash-tab" key={rowIndex}>
                          {TestDates.map((date, colIndex) => {
                            const testData = user[date];
                            return (
                              <React.Fragment key={colIndex}>
                                {colIndex === 0 &&
                                  (rowIndex === UserData.length - 1 ? (
                                    <div className="col-md-2_5">
                                      <p>Quizzes Taken</p>
                                    </div>
                                  ) : (
                                    <div className="col-md-2_5"></div>
                                  ))}

                                <div className="col-md-2_5">
                                  {testData && (
                                    <>
                                      <div
                                        style={{
                                          backgroundColor:
                                            Bgcolors[
                                              colIndex % Bgcolors.length
                                            ],
                                        }}
                                        onClick={() => {
                                          if (testData?.test_link) {
                                            window.location.href = `/${testData.test_link}`;
                                          }
                                        }}
                                      >
                                        
                                         {testData?.conductor_image ? (

                                            <img
                                              src={`${IMG_URL}/d0/${testData?.conductor_image}`}
                                              alt={
                                                testData?.conducter_name
                                              }
                                            />

                                        ) : (

                                            <img src={noimage} />
                                              
                                        )}

                                        <span>{testData?.conducter_name}</span>
                                      </div>
                                      <p>{testData?.test_name}</p>
                                    </>
                                  )}
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="col-md-12 last-date">
                  <div className="row newdash-tab">
                    <div className="col-md-2_5">Date</div>
                    {TestDates &&
                      TestDates.length > 0 &&
                      TestDates.map((item, index) => (
                        <div key={index} className="col-md-2_5">
                          {item}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

   <div className="back-dahboard">
            <a className="button back-return" href="/dashboard">
              {backButton}
              <span>
                <FontAwesomeIcon className="icc" icon={faArrowRight} />
              </span>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ArchetypeTimeline;
